var map = {
	"./en-US.json": "kwaH",
	"./et-EE.json": "GmH1",
	"./ru-RU.json": "OeC+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cTjz";


//////////////////
// WEBPACK FOOTER
// ./src/localization [A-Za-z0-9-_,\s]+\.json$/
// module id = cTjz
// module chunks = 1